import {Component, ViewEncapsulation} from '@angular/core';
import {BaseCellEditorComponent} from '../base-cell-editor/base-cell-editor.component';
import {FormsModule} from '@angular/forms';
import {TextElementComponent} from "../../../form-control/dynamic-form/form-element/text-element/text-element.component";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'kpi4me-number-cell-editor',
  templateUrl: './number-cell-editor.component.html',
  styleUrls: ['./number-cell-editor.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [FormsModule, TextElementComponent, MatTooltip],
})
export class NumberCellEditorComponent extends BaseCellEditorComponent {

}
